export default __webpack_public_path__ + "static/media/pic1.83fe7358.jpg";